import { UserType } from "@/data/campaign-types";

type SignupUserData = {
  full_name?: unknown;
  agency_name?: unknown;
  referral_code?: unknown;
};

export const buildSignupMetadata = (
  userType: UserType,
  userData: SignupUserData,
) => {
  const metadata: {
    user_type: UserType;
    full_name: unknown;
    agency_name?: string;
    referral_code?: string;
  } = {
    user_type: userType,
    full_name: userData.full_name,
  };

  if (userType === "agency" && typeof userData.agency_name === "string") {
    metadata.agency_name = userData.agency_name.trim();
  }

  if (userType === "creator" && typeof userData.referral_code === "string") {
    const referralCode = userData.referral_code.trim().toUpperCase();
    if (referralCode) {
      metadata.referral_code = referralCode;
    }
  }

  return metadata;
};
